const LoginUser = (user) => {
  return {
    type: "LOGIN_USER",
    user,
  };
};

const LogoutUser = () => {
  return {
    type: "LOGOUT_USER",
  };
};

const ExcelSummary = (data) => {
  return {
    type: "EXCEL_SUMMARY",
    data,
  };
};

const GetProvinces = (data) => {
  return {
    type: "GET_PROVINCES",
    data,
  };
};

const GetUsers = (data) => {
  return {
    type: "GET_USERS",
    data,
  };
};

export const Actions = {
  LoginUser,
  LogoutUser,
  ExcelSummary,
  GetProvinces,
  GetUsers,
};
